import { injectable } from 'tsyringe'
import { TrainingMaterialApiRepository } from '@/app/repositories/api/TrainingMaterialRepository'
import { TrainingMaterial } from '@/domain/entities/TrainingMaterial'
import {
  PostTrainingMaterialInterface,
  DeleteTrainingMaterialInterface,
  UpdateTrainingMaterialInterface,
} from '@/data/payload/contracts/TrainingMaterialRequest'
@injectable()
export class TrainingMaterialPresenter {
  private repository: TrainingMaterialApiRepository

  constructor(repository: TrainingMaterialApiRepository) {
    this.repository = repository
  }

  public loadTrainingMaterial(params: Object): Promise<TrainingMaterial> {
    return this.repository.getAll(params)
  }

  public postTrainingMaterial(
    payload: PostTrainingMaterialInterface
  ): Promise<TrainingMaterial> {
    return this.repository.post(payload)
  }

  public updateTrainingMaterial(
    payload: UpdateTrainingMaterialInterface,
    id: number
  ): Promise<TrainingMaterial> {
    return this.repository.update(payload, id)
  }

  public deleteTrainingMaterial(
    payload: DeleteTrainingMaterialInterface
  ): Promise<TrainingMaterial> {
    return this.repository.delete(payload)
  }
}
